export default function ProfilingResultCN({ answer, error, loading, onCopy }) {
  return (
    <div className="profilingResult mrt30">
      <div className="answer">
        {loading ? (
          <p>创建中... 请稍等。</p>
        ) : error ? (
          <p className="error">{error}</p>
        ) : answer ? (
          <div><div dangerouslySetInnerHTML={{ __html: answer }} /></div>
        ) : (
          <p>粘贴问诊数据，然后点击"生成配置文件"。</p>
        )}
      </div>
    </div>
  );
}
